// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ePxgMqfJhXukIQ9Z3W4w p{margin-bottom:24px}`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/SupportedCountriesModal.module.scss"],"names":[],"mappings":"AACC,wBACC,kBAAA","sourcesContent":[".supportedCountriesBody {\n\tp {\n\t\tmargin-bottom: 24px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"supportedCountriesBody": `ePxgMqfJhXukIQ9Z3W4w`
};
export default ___CSS_LOADER_EXPORT___;
